import axios from "axios";
import { addtocart, getcart } from "../apiConfig";
import { getToken } from "../../localstorage";

const post_addtocart = async (
  healthpackage_id = 0,
  action,
  cart_id = 0,
  quantity = 1
) => {
  const postData = {
    healthpackage_id: healthpackage_id,
    action: action,
    cart_id: cart_id,
    quantity: quantity,
  };

  try {
    const response = await axios.post(addtocart, postData, {
      headers: {
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const get_cartinfo = async (lang) => {
  const params = {
    lang: lang,
  };
  try {
    const response = await axios.get(getcart, {
      params: params,
      headers: {
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
export { post_addtocart, get_cartinfo };
